<template>
    <div> 
        <Header :active="4" @show-contact="showContact" :title="'技术支持'"></Header>
        <div class="main">
            <aslide class="sidebar" >
                <div class="title">慧建智联 丨 技术支持</div>
                <div class="text">
                    <a @click="showDetail('support')" :class="{ active: currentDetail === 'support' }">支持说明</a>
                    <!-- <a @click="showDetail('faq')" :class="{ active: currentDetail === 'faq' }">常见问题</a> -->
                </div>
                <hr style="color: rgb(65,65,65,1);width: 90%;"></hr>
                <div class="type">
                    产品
                    <div class="select">
                        <select class="select-box">
                            <option value="content1">XR-2</option>
                            <!-- <option value="content2">VR-1</option> -->
                        </select>
                    </div>
                </div>
                <div class="file">
                    <!-- <a @click="showDetail('hjtool')" :class="{ active: currentDetail === 'hjtool' }">AIXR Agent</a> -->
                    <a @click="showDetail('sdk')" :class="{ active: currentDetail === 'sdk' }">开发者支持</a>
                </div>
            </aslide>
            <div class="detail" id="faq" v-if="currentDetail === 'support'">
                <h2>支持说明</h2>
                <p>慧建智联为您提供全方位、高效的技术支持服务，确保您在使用我们的产品或服务时能够畅通无阻。为了帮助您快速解决遇到的问题，我们提供了多种便捷的支持渠道。</p>
                <p>首先，您可以在我们的官方网站上搜索常见问题及解决方案。我们精心整理了大量用户可能遇到的常见问题，并提供了详细的解答步骤，让您在遇到问题时能够迅速找到解决办法。</p>
                <!-- <a @click="showDetail('faq')">常见问题→</a> -->
                <p>此外，针对视景开发团队，我们还提供了最新版本的SDK下载服务。通过下载最新的SDK，您可以获得最新的产品功能和性能优化，确保您的项目在我公司硬件产品上能够始终保持最佳运行状态。</p>
                <p>同时，我们也为您准备了详尽的安装配置文档。这些文档详细描述了产品的安装步骤、配置方法以及注意事项，让您能够轻松完成产品的部署和配置工作。</p>
                <p>无论您遇到任何问题或需要进一步的帮助，我们的技术支持团队都将随时为您提供专业的支持和解答。请随时联系我们，我们将竭诚为您服务！</p>
            </div>
            <div class="detail" id="faq" v-if="currentDetail === 'faq'">
                <h2>常见问题</h2>
            </div>
            <div class="detail" id="hjtool" v-if="currentDetail === 'hjtool'">
                <div class="top">
                    <h2>AIXR Agent</h2>
                    <button @click="downloadTool">下载最新安装文件</button>
                </div>
                <hr style="color: #f2f2f2;width: 100%;"></hr>
                <!-- <p style="padding: 0.2rem 0">V 1.2.73    2025.02.26 更新</p>
                <p>更新说明：<br>
                    - rom集成全动机适配功能，加入tracker对齐和随动; <br>
                    - HJMRapk改blender方式，非颜色挖孔；<br>
                    - 添加启动的进度条；<br>
                </p> -->
            </div>
            <div class="detail" id="sdk" v-if="currentDetail === 'sdk'">
                <div class="top">
                    <h2>开发者支持</h2>
                    <!-- <button @click="downloadSDK">下载最新SDK</button> -->
                </div>
                <hr style="color: #f2f2f2;width: 100%;"></hr>
                <p style="padding: 0.2rem 0">XR2 SDK 插件下载</p>
                <p></p>
                <button @click="downloadSDK(0)">下载UE SDK</button></br></br>
                <button @click="downloadSDK(1)">下载Unity SDK</button>
            </div>
        </div>
        <!-- 结尾 -->
        <Footer></Footer>
        <Contact v-if="isContactVisible" @close="close"></Contact>
        <Email @show-contact="showContact"></Email>
    </div>
</template>
<script>
import Footer from '../components/Footer.vue'
import Header from '../components/Head.vue'
import Contact from '../components/Contact.vue'
import Email from '../components/Email.vue'
export default {
    name: 'Support',
    data() {
        return {
            isContactVisible: false,
            currentDetail: 'support'
        }
    },
    components: {
        Footer,
        Header,
        Contact,
        Email
    },
    created() {
    },

    methods: {
       
        showContact() {
            this.isContactVisible = true;
        },
        close() {
            this.isContactVisible = false;
        },
        showDetail(detail) {
            this.currentDetail = detail;
        },
        downloadTool() {
            window.location.href = 'https://www.huijianzhilian.com/download/hjtool/1.2.73.zip';
        },
        downloadSDK(a) {
            if(a == 0){
                window.location.href = 'https://www.huijianzhilian.com/download/sdk/AIXR_Agent_UE.zip';
            }else{
                window.location.href = 'https://www.huijianzhilian.com/download/sdk/AIXR_Agent_Unity.zip';
            }
        }
    }
}
</script>
<style scoped>
@import '../assets/css/supportStyle.css';
</style>